/** @flow */

// Nested schemas
const schemaNestedProperties = ["organisationalUnit", "shiftPattern", "staffGroup"];

// Needed to transform data back to schema format we get from the server
// Returns nested schemas from root level to it's origin positions
export const transformToRequestData = (data: Object) =>
  schemaNestedProperties.reduce(
    (acc: Object, property) => {
      if (acc[property]) {
        acc[property] = {
          id: acc[property],
        };
      } else {
        acc[property] = null;
      }

      return acc;
    },
    { ...data },
  );

// Needed to move nested schemas to root schema level to prevent incorrect validation by json-schema-form
export const transformToSchemaFormData = (data: Object) =>
  schemaNestedProperties.reduce(
    (acc: Object, property) => {
      if (acc[property]) {
        acc[property] = acc[property].id;
      }

      return acc;
    },
    { ...data },
  );
